// @ts-nocheck
import React from "react";
import ChatBot from "react-simple-chatbot";
import FetchAnswer from "./FetchAnswer";

const ChatComponent = () => {
  const steps = [
    { id: "1", message: "¡Hola! voy ayudarte a seleccionar un personal, por favor indicame un tipo de perfil", trigger: "optionsProfile" },
    { 
      id: "optionsProfile",
      options: [
        { value: "Abogado", label: "Abogado", trigger: "messageProfile" },
        { value: "Arquitecto", label: "Arquitecto", trigger: "messageProfile" },
        { value: "custom", label: "Escribir perfil", trigger: "userInputProfile" },
        { value: "end", label: "Terminar chat", trigger: "end" },
      ] 
    },
    { id: "userInputProfile", user: true, trigger: "messageProfile" },
    { id: "messageProfile", message: "Escribe la pregunta acerca del perfil: {previousValue}", trigger: "userInputQuestion"},
    { id: "userInputQuestion", user: true, trigger: "fetchCustom" },
    { id: "fetchCustom", component: <FetchAnswer />, asMessage: true, trigger: "userInputQuestion", waitAction:true },
    {id: 'end', message: 'Bye!',end: true }
  ];

  return (
    <ChatBot
      steps={steps}
      userDelay={500}
      placeholder="Escribe el mensaje"
      headerTitle="Caleidos Chatboot"
    />
  );
};

export default ChatComponent;
